ismfast.directive('format', ['$filter', '$parse', function ($filter, $parse) {
    return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            if (!ngModel) return;

            elem.bind("keydown keypress", (event) => {
                if (event.which === 109 || event.which === 189) {
                    event.preventDefault();
                }
            });

            function format(value) {
                let plainNumber = value ? value.replace(/[^\d|\-+|\.+]/g, "") : "";
                plainNumber = plainNumber.replace("-", "");
                return plainNumber === "" ? 0 : plainNumber;
            }

            function castInt(value) {
                let returnValue = attrs.format === "number" ? parseInt(value) : value;
                return returnValue;
            }

            // format model value into view value
            ngModel.$formatters.unshift((modelValue) => {
                $parse(attrs.ngModel).assign(scope, castInt(format(modelValue))); // set model value
                return $filter(attrs.format)(ngModel.$modelValue); // return view value
            });

            // format view value into model value
            ngModel.$parsers.unshift((viewValue) => { // updates via user input
                elem.val($filter(attrs.format)(format(viewValue))); // format view value
                return castInt(format(viewValue)); // return model value
            });
        }
    };
}]);


ismfast.directive('numbersOnly', function(){
    return {
        require: 'ngModel',
        restrict: 'ACE',
        link: function(scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {


                if (inputValue == undefined) {
                    return '';
                }

                var firstParse = inputValue.replace(/[^0-9 . -]/g, '');

                var safeParse = firstParse.charAt(0);
                var prepParse = firstParse.substring(1,firstParse.length);

                var secondParse = safeParse + prepParse.replace(/[^0-9 .]/g, '');

                var n = secondParse.indexOf(".");
                var transformedInput;


                if (n == -1) {
                    transformedInput = secondParse;
                }
                else {
                    transformedInput = secondParse;

                    safeParse = secondParse.substring(0,n+1);
                    firstParse = (secondParse.substring(n+1,secondParse.length)).replace(/[^0-9]/g, '');
                    n = 2;

                    if (firstParse.length <= n) {
                        transformedInput = safeParse + firstParse;
                    }
                    else {
                        transformedInput = safeParse + firstParse.substring(0,n);
                    }
                }

                var min = parseInt(attrs.minvalue);
                var max = parseInt(attrs.maxvalue);
                var returnValue;
                returnValue=transformedInput;
                if (transformedInput!=inputValue ||
                    transformedInput < min ||
                    transformedInput > max) {



                    if (transformedInput < min || transformedInput > max) {
                        returnValue = transformedInput.substring(0,transformedInput.length-1);
                    }
                    else {
                        returnValue=transformedInput;
                    }
                    modelCtrl.$setViewValue(returnValue);
                    modelCtrl.$render();
                }

                return returnValue;
            });
        }
    };
});

ismfast.directive('selectOnClick', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            element.on('click', function () {
                this.select();
            });
        }
    };
});

ismfast.directive('ngEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if(event.which === 13) {
                scope.$apply(function (){
                    scope.$eval(attrs.ngEnter);
                });

                event.preventDefault();
            }
        });
    };
});

ismfast.directive('focusOn', function() {
    return function(scope, elem, attr) {
        scope.$on('focusOn', function(e, name) {
            if(name === attr.focusOn) {
                elem[0].focus();
            }
        });
    };
});

ismfast.directive('focus', function() {
    return {
        restrict: 'A',
        link: function($scope,elem,attrs) {

            elem.bind('keydown', function(e) {
                var code = e.keyCode || e.which;
                if (code === 13) {
                    e.preventDefault();
                    elem.next().focus();
                }
            });
        }
    }
});


ismfast.factory('focus', function ($rootScope, $timeout) {
    return function(name) {
        $timeout(function (){
            $rootScope.$broadcast('focusOn', name);
        });
    }
});

